<template>
<div>
    <!-- <vue-element-loading :active="isLoading" is-full-screen text="Please wait..." /> -->
    <component :is="this.headerFooter.header"></component>
    <div class="container">
        <ReportInfo :reportInfo="reportInfo"/>
        <SpReport style="margin-top:60px;" />
        <ReportAllData style="margin-top:20px;" />
        <AI style="margin-top:20px;margin-bottom:60px;" />
    </div>
</div>
</template>
<script>
import Header from '@/components/Header.vue';
import ReportInfo from '@/components/sp_report/report_info.vue'
import SpReport from '@/components/sp_report/sp_report.vue'
import ReportAllData from '@/components/sp_report/report_allData.vue'
import AI from '@/components/sp_report/ai.vue'
import store from "@/store"
export default {
    data() {
        return {
            client_account: '',
            report_id: '',
            doc_account: 'cherng0125',
            reportInfo: [],
            isLoading: false,
        }
    },
    components: {
        Header,
        ReportInfo,
        SpReport,
        ReportAllData,
        AI
    },
    created(){
        const report = JSON.parse(sessionStorage.getItem('client_report'));
        this.reportInfo = report
        const user = JSON.parse(sessionStorage.getItem('my_info'));
        if(user === null){
            alert("请重新登入");
            this.$router.push('/login');
        }
    },
    computed: {
        headerFooter() {
            return store.getters['auth/isLoggedIn'] ? {
                header: Header,
            } : {
                header: Header,
            }
        },
    },
    methods: {

    }
}
</script>